import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "pill", "number", "check", "hint"]

  static values = {
    key: String,
    completeLabel: String
  }

  connect() {
    if (window.sessionStorage.getItem(this.keyValue) === "1") this.markComplete()
  }

  complete() {
    if (this.buttonTarget.disabled) return

    window.sessionStorage.setItem(this.keyValue, "1")
    this.markComplete()
  }

  markComplete() {
    this.element.classList.add("--complete")
    this.element.classList.remove("--pending", "--todo")

    if (this.hasPillTarget) {
      this.pillTarget.textContent = this.completeLabelValue
      this.pillTarget.className = "journey-timeline__pill bg-status-complete"
    }

    if (this.hasNumberTarget) this.numberTarget.hidden = true
    if (this.hasCheckTarget) this.checkTarget.hidden = false
    if (this.hasHintTarget) this.hintTarget.hidden = true

    this.buttonTarget.disabled = true
    this.buttonTarget.classList.remove("--locked")
    this.buttonTarget.setAttribute("aria-pressed", "true")
    this.buttonTarget.textContent = this.completeLabelValue
  }
}
